import axios from 'axios';
import URLS from '../../util/urls.js';
import funcoes from '../../util/funcoes.js';

const state = {
  listaContasReceber: [],
  contaReceberPesquisa: {
    pagina: 0,
    cliente: {},
    vencimentoInicio: funcoes.primeiroDiaMes(),
    vencimentoFim: funcoes.ultimoDiaMes(),
    contaPlanoConta: {
      grupoPlanoConta: {
       tipo: 'RECEITA' 
      }
    }
  },
  labelQuantidade: '',
  contaReceberSelecionado: {
    id: 0,
    status: 'PROVISORIA',
    contaBancaria: { nome: '' },
    periodicidade: 30,
    quantidadeParcelas: 2
  },
  lancamentoSelecionado: {
    id: 0,
    conta: { id: 0 },
    contaBancaria: { id: 0 },
    status: 'ABERTO'
  },
  planosDisponiveis: [],
  clientesDisponiveis: [],
  logs: [],
}

const mutations = {
  atualizarListaContasReceber(state, payload) {
    if(state.contaReceberPesquisa.pagina === 0) {
      state.listaContasReceber = payload.lista;
    } else {
      state.listaContasReceber.push(...payload.lista);
    }

    state.labelQuantidade = payload.lista.length + (payload.lista.length == 1 ? " conta encontrada" : " contas encontradas");
  },
  limparContasReceberListadas(state) {
    state.listaContasReceber = [];
  },
  limparContaReceberPesquisa(state) {
    state.contaReceberPesquisa = {
      pagina: 0,
      cliente: {},
      vencimentoInicio: funcoes.primeiroDiaMes(),
      vencimentoFim: funcoes.ultimoDiaMes(),
      contaPlanoConta: {
        grupoPlanoConta: {
         tipo: 'RECEITA' 
        }
      }
    };
  },
  atualizarContaReceberSelecionado(state, payload) {
    state.contaReceberSelecionado = payload;
    if(!payload.juros) { state.contaReceberSelecionado.juros = 0 }
    if(!payload.multa) { state.contaReceberSelecionado.multa = 0 }
    state.planosDisponiveis = payload.contaPlanoConta ? [payload.contaPlanoConta] : [];
    state.clientesDisponiveis = payload.cliente ? [payload.cliente] : [];
  },
  novoContaReceber(state) {
    state.contaReceberSelecionado = {
      id: 0,
      status: 'PROVISORIA',
      contaBancaria: { nome: '' },
      periodicidade: 30
    }
    state.lancamentoSelecionado = {
      id: 0,
      conta: { id: 0 },
      contaBancaria: { id: 0 },
      status: 'ABERTO'
    }

    state.logs = [];
  },
  novoLancamento(state) {
    state.lancamentoSelecionado = {
      id: 0,
      conta: { id: 0 },
      contaBancaria: { id: 0 },
      status: 'ABERTO'
    }
  },
  atualizarLancamentoSelecionado(state, payload) {
    state.lancamentoSelecionado = {
      ...payload,
      dataPagamento: payload.dataPagamento ? payload.dataPagamento : funcoes.hoje()
    };
  },
  atualizarPlanosDisponiveis(state, payload) {
    state.planosDisponiveis = payload;
  },
  atualizarClientesDisponiveis(state, payload) {
    state.clientesDisponiveis = payload;
  },

  atualizarLogs(state, logs) {
    state.logs = logs;
  },
  limparLogs(state) {
    state.logs = [];
  },
}

const actions = {
  listarContasReceber(context, payload) {
    return axios.post(URLS.CONTAS_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarListaContasReceber', response.data);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('listarContasReceber', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    })
  },
  limparContasReceberListadas(context) {
    context.commit('limparContasReceberListadas');
  },
  limparContaReceberPesquisa(context){
    context.commit('limparContaReceberPesquisa');
  },
  recuperarContaReceber(context, payload) {
    return axios.post(URLS.CONTAS_RECUPERAR, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarContaReceberSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('recuperarContaReceber', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  novoContaReceber(context) {
    context.commit('novoContaReceber');
  },
  gravarContaReceber(context, payload) {
    return axios.post(URLS.CONTAS_GRAVAR, payload)
      .then(response => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarContaReceberSelecionado', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('gravarContaReceber', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
      throw error;
    });
  },
  aprovarContaReceber(context, payload) {
    return axios.post(URLS.CONTAS_APROVAR, payload)
      .then(response => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarContaReceberSelecionado', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('aprovarContaReceber', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
      throw error;
    });
  },
  desaprovarContaReceber(context, payload) {
    return axios.post(URLS.CONTAS_DESAPROVAR, payload)
      .then(response => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarContaReceberSelecionado', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('desaprovarContaReceber', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
      throw error;
    });
  },
  removerContaReceber(context, payload) {
    return axios.post(URLS.CONTAS_REMOVER, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('novoContaReceber');
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('removerContaReceber', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
    }).catch((error) => {
      throw error;
    });
  },
  
  cancelarContaReceber(context, payload) {
    return axios.post(URLS.CONTAS_CANCELAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "ERRO":
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('cancelarContaReceber', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            context.commit('atualizarContaReceberSelecionado', response.data.item);
            return response.data;
        }
    }).catch((error) => {
      throw error;
    });
  },

  listarPlanos(context, payload) {
    return axios.post(URLS.PLANO_CONTA_LISTAR, payload)
    .then(response => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarPlanosDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarPlanos', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarPlanosDisponiveis', []);
          return response.data;
      }
    });
  },
  listarClientes(context, payload) {
    return axios.post(URLS.CLIENTES_LISTAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarClientesDisponiveis', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('listarClientes', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          context.commit('atualizarClientesDisponiveis', []);
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  // LANCAMENTOS
  novoLancamento(context,payload){
    context.commit('novoLancamento',payload);
  },
  atualizarLancamentoSelecionado(context,payload){
    context.commit('atualizarLancamentoSelecionado',payload);
  },
  gravarLancamento(context, payload) {
    return axios.post(URLS.LANCAMENTOS_GRAVAR, payload)
      .then(response => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarContaReceberSelecionado', response.data.item);
            return response.data;
          case "FALHA":
            context.commit('atualizarContaReceberSelecionado', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === 'SUCESSO') {
                  return context.dispatch('gravarLancamento', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
      throw error;
    });
  },
  recuperarLancamento(context, payload) {
    return axios.post(URLS.LANCAMENTOS_RECUPERAR, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarLancamentoSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('recuperarLancamento', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerLancamentoConta(context, payload) {
    return axios.post(URLS.LANCAMENTOS_REMOVER, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarContaReceberSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('removerLancamentoConta', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  pagarLancamento(context, payload) {
    return axios.post(URLS.LANCAMENTOS_PAGAR, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.dispatch('recuperarContaReceber', payload.conta);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('pagarLancamento', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  cancelarPagamentoLancamento(context, payload) {
    return axios.post(URLS.LANCAMENTOS_CANCELAR, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarContaReceberSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('cancelarPagamentoLancamento', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gerarRecibo(context, payload) {
    return axios.post(URLS.RELATORIOS_GERAR, payload).then(response => {
      switch(response.data.status) {
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true }).then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('gerarRecibo', payload);
            }
          }).catch(error => { throw error });
        default:
          return response.data;
      }
    }).catch(error => { throw error });
  },
  devolverCheque(context, payload) {
    return axios.post(URLS.LANCAMENTOS_DEVOLVER_CHEQUE, payload).then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarContaReceberSelecionado', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true})
            .then((authResponse) => {
              if(authResponse.status == "SUCESSO") {
                return context.dispatch('devolverCheque', payload);
              }
            }).catch((error) => {
              throw error;
            });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarLogs(context, payload) {
    return axios.post(URLS.LOGGER_LISTAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          context.commit('atualizarLogs', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('recuperarLogs', payload);
            }
          }).catch(error => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch(error => {
      throw error;
    });
  },

  gerarBoletoLancamento(context, payload) {
    return axios.post(URLS.LANCAMENTOS_BOLETO_GERAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
        case "FALHA":
        case "ERRO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch("loginStore/relogar", {}, { root: true })
          .then((authResponse) => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch("gerarBoletoLancamento", payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  
  enviarBoletoLancamento(context, payload) {
    return axios.post(URLS.LANCAMENTOS_BOLETO_ENVIAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == 'SUCESSO') {
              return context.dispatch('enviarBoletoLancamento', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  prorrogarLancamento(context, payload) {
    return axios.post(URLS.LANCAMENTOS_PRORROGAR, payload).then(response => {
      switch (response.data.status) {
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true }).then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('prorrogarLancamento', payload)
            }
          }).catch(error => { throw error });

        case 'SUCESSO':
          context.state.contaReceberSelecionado.lancamentos = response.data.lista;
          return response.data;

        default:
          return response.data;
      }
    }).catch(error => { throw error });
  },

  calcularLancamento(context, payload) {
    return axios.post(URLS.LANCAMENTOS_CALCULAR, payload)
    .then((response) => {
      switch (response.data.status) {
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true }).then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('calcularLancamento', payload)
            }
          }).catch(error => { throw error });
        default:
          return response.data;
      }
    }).catch(error => { throw error });
  },

  cancelarProrrogacaoLancamento(context, payload) {
    return axios.post(URLS.LANCAMENTOS_CANCELAR_PRORROGACAO, payload).then(response => {
      switch (response.data.status) {
        case 'SESSAO_EXPIRADA':
          return context.dispatch('loginStore/relogar', {}, { root: true }).then(authResponse => {
            if(authResponse.status === 'SUCESSO') {
              return context.dispatch('cancelarProrrogacaoLancamento', payload)
            }
          }).catch(error => { throw error });

        case 'SUCESSO':
          context.state.contaReceberSelecionado.lancamentos = response.data.lista;
          return response.data;

        default:
          return response.data;
      }
    }).catch(error => { throw error });
  }
}

export default {
  state,
  mutations,
  actions
}